<script>
  import { languages } from './BCP47LanguagesAndTags';
  import { External, M } from '../../external';

  export let caption = {};
  export let removeCaption = () => {};

  let selectedLanguage = caption.tag || 'en';
  let selectedCaptionFileName = caption.url ? caption.url.split('/').pop() : '';

  let selectCaption = (e) => {
    e.preventDefault();
    External.FileManager.selectFile({
      listImagesOnly: false,
      onCompleteCallback: (fileBase, fileName, displayName) => {
        selectedCaptionFileName = fileName.split('/').pop();
        caption.url = External.getFileFromBase(fileBase) + fileName;
      }
    });
  };

  let makeDefault = () => {
    caption.isDefault = true;
  };

  let onSelectedLanguageChange = () => {
    let language = languages.find((language) => language.tag === selectedLanguage);
    caption.tag = language.tag;
    caption.lang = language.lang;
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-25 mb-15">
    <span class="material-icons-outlined fingerprint-icon"> closed_caption </span>
  </div>
  <h4 class="col20 f-left mb-15 t-center h4-bigger">{M.LANGUAGE_NAME}</h4>
  {#if !caption.isNew}
    <div class="col20 f-left t-center">
      <a on:click={() => removeCaption(caption)} class="middle-button red inline-block f-none">{M.DELETE_LANGUAGE}</a>
    </div>
  {/if}

  <div class="col20 f-left t-center mt-15">
    <div class="popup-input-wrapper">
      <input
        class="template-select select-like"
        on:click={selectCaption}
        readonly="readonly"
        placeholder={selectedCaptionFileName} />
      <input type="hidden" value="-1" />
    </div>
    <div class="caption-language col20 f-left">
      <div class="col20 f-left t-center mt-15">
        <h4>{M.SELECT_LANGUAGE}</h4>
        <select bind:value={selectedLanguage} on:change={onSelectedLanguageChange}>
          {#each languages as language}
            <option value={language.tag}>{language.lang}</option>
          {/each}
        </select>
      </div>
    </div>
  </div>

  {#if caption.isDefault}
    <!-- Auto Enable the caption -->
    <div class="col20 f-left t-center mt-5">
      <div class="checkbox-wrapper">
        <input
          bind:checked={caption.autoEnable}
          value="autoEnable"
          id="autoEnable"
          class="css-checkbox"
          name="autoEnable"
          type="checkbox" />
        <label for="autoEnable" class="css-label">{M.AUTOMATICALLY_ENABLE_CAPTION}</label>
      </div>
    </div>
  {:else}
    <div class="col20 f-left t-center mt-5">
      <a class="text-link-small t-center blue-text" on:click={makeDefault}>{M.DEFAULT_LANGUAGE}</a>
    </div>
  {/if}
</div>
